import styled from 'styled-components';

import DoubleColumnSection, {
  DoubleColumnSectionProps,
} from 'components/DoubleColumnSection/DoubleColumnSection';
import { Categories } from 'components/DoubleColumnSection/DoubleColumnSection.styles';
import RichText from 'components/RichText/RichText';
import { setTypography } from 'utils/styles/mixins';
import { FontNames, fonts } from 'utils/styles/theme';

interface EmailsProps {
  margin?: boolean;
}

export const Wrapper = styled.div`
  display: grid;
  grid-row-gap: 32px;

  padding: 48px 0;
`;

export const TextRich = styled(RichText)<EmailsProps>`
  ${({ theme: { locale } }) => setTypography('smallBody', locale)};
  font-family: ${fonts.face[FontNames.sequelSans]};
  ${({ margin }) => margin && 'margin-top: 23px'};
`;

export const Emails = styled.div<EmailsProps>`
  ${({ margin }) => !margin && 'margin-top: 23px'};
`;

export const RichTextWrapper = styled(RichText)`
  ${({ theme: { locale } }) => setTypography('heading1', locale)};
`;

export const ExpertiseSection = styled(
  DoubleColumnSection
)<DoubleColumnSectionProps>``;

export const GetInTouchSection = styled(
  DoubleColumnSection
)<DoubleColumnSectionProps>`
  ${Categories} div img {
    margin: 16px 0 0;

    &:first-child {
      margin: 0 0 16px;
    }
  }

  ${Categories} div a {
    width: fit-content;
    display: block;
    margin: 16px 0 0;

    img {
      margin: 0 !important;
    }
  }

  p {
    margin: 0;
  }
`;

export const SocialsContainer = styled.section`
  margin: 8px 0 0;
`;
